var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.6,
    d: "M15.333 8.072v13.334H4.667V8.072zm-2-8H6.667L5.333 1.406H.667v2.666h18.666V1.406h-4.666zM18 5.406H2v16c0 1.466 1.2 2.666 2.667 2.666h10.666c1.467 0 2.667-1.2 2.667-2.666z"
  })));
};
export default SvgDelete;